"use client";

import Link from "next/link";
import { useResource } from "@/hooks/useResource";
import { IRobot, IRobotRunner } from "@/types/robot";
import { Skeleton } from "@/components/Skeleton";
import { Badge, Button, Card } from "flowbite-react";

export default function Robots() {
  const { data = [], isLoading } = useResource<
    (IRobot & { watcher_robots_runners: IRobotRunner[] })[]
  >("watcher_robots", "id, name, steps, watcher_robots_runners ( id )");
  return (
    <div className="w-full max-w-5xl">
      <div className="mb-3 flex flex-row justify-between items-center">
        <p>My Robots</p>
        <Link href="/dashboard/robots/create">
          <Button>Create A Robot</Button>
        </Link>
      </div>
      {isLoading && (
        <div>
          <div className="w-full flex flex-col gap-3">
            <Skeleton className="w-full h-5" />
            <Skeleton className="w-full h-5" />
            <Skeleton className="w-full h-5" />
            <Skeleton className="w-full h-5" />
          </div>
        </div>
      )}
      <div className="flex flex-col gap-3">
        {(data || []).map((item) => (
          <Link key={item.id} href={`/dashboard/robots/${item.id}/start`}>
            <Card className="rounded">
              <div className="flex flex-row align-center gap-2">
                <p>{item.name}</p>
                <Badge color="success">
                  Total Steps {item.steps.length}
                </Badge>
                <Badge>{`Runners: ${item.watcher_robots_runners?.length}`}</Badge>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
